import { useTileHeadingLevel } from "@/components/ui/tile-heading-context";

/**
 * The one heading anatomy every seat Home widget uses: a name, then at most
 * one quiet line that orients, such as a count or the zone class times are in.
 *
 * The line sits under the name rather than above it as an eyebrow, so every
 * widget on the page reads name-first and no two headings use different
 * voices for the same job.
 */
export function WidgetHeading({
  id,
  children,
  meta,
  focusable = false,
}: {
  id: string;
  children: React.ReactNode;
  meta?: React.ReactNode;
  /** Preserve exact heading focus when an owner sheet closes. */
  focusable?: boolean;
}) {
  const Heading = useTileHeadingLevel();
  return (
    <div className="min-w-0">
      <div className="flex min-h-[1.875rem] items-center"><Heading id={id} tabIndex={focusable ? -1 : undefined} className="min-w-0 break-words text-section font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{children}</Heading></div>
      {meta && <p className="text-meta text-muted-foreground">{meta}</p>}
    </div>
  );
}
